import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, Route, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { paths, SesionService } from './services/sesion.service';
import { LanguageService } from './services/language.service';

@Injectable({providedIn: 'root'})
export class OfflineGuard  {
  constructor(private router: Router, private sesion: SesionService, private langService: LanguageService){
  }
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.checkOffline();
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.checkOffline();
  }

  private checkOffline() {
    if (environment.offline) {
      const subscription = this.langService.language$.subscribe((idioma) => {
        if (idioma === '') {
          idioma = 'es';
        }
        this.router
          .navigate([paths.offline[idioma]])
          .then(() => {
            subscription.unsubscribe();
          })
          .catch(() => {
            subscription.unsubscribe();
          });
      });
    }
    return !environment.offline;
  }
}
